import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class BbvaMovementsService {
  constructor(private http: HttpClientService) {}

  public getDuplicatedClabes(bbva_movements = []) {
    return this.http
      .post("/api/bbva_movements/duplicated_clabes", { bbva_movements })
      .pipe(tap((_) => console.log("BbvaMovementsService.getDuplicatedClabes: Ok.")));
  }

  public analyzeBBVAPayments(bbva_movements = []) {
    return this.http
      .post("/api/bbva_movements/analyze_bbva_movement", { bbva_movements })
      .pipe(tap((_) => console.log("BbvaMovementsService.analyzeBBVAPayments: Ok.")));
  }

  public analyzeCash(content): Observable<any> {
    return this.http
      .post("/api/bbva_movements/analyze_cash", { content })
      .pipe(tap((_) => console.log("BbvaMovementsService.analyzeCash: Ok.")));
  }

  public reconcileCocincidences(bbva_movements = []) {
    return this.http
      .post("/api/bbva_movements/previously_reconciled_payments", { bbva_movements })
      .pipe(tap((_) => console.log("BbvaMovementsService.reconcileCocincidences: Ok.")));
  }

  public RFCCoincidences(bbva_movements = []) {
    return this.http
      .post("/api/bbva_movements/coincidencia_by_rfc", { bbva_movements })
      .pipe(tap((_) => console.log("BbvaMovementsService.RFCCoincidences: Ok.")));
  }

  public matchByFullName(bbva_movements = []) {
    return this.http
      .post("/api/bbva_movements/match_by_payer_name", { bbva_movements })
      .pipe(tap((_) => console.log("BbvaMovementsService.matchByFullName: Ok.")));
  }

  public getUnassignedBBVAMovements({
    page_number = undefined,
    page_size = undefined,
    start_date = undefined,
    end_date = undefined,
    file_type = undefined,
    payment_method = undefined,
    order_by = undefined,
    order_dir = undefined,
  }) {
    const options: any = {
      params: {
        page_number,
        page_size,
        start_date,
        end_date,
        file_type,
        payment_method,
        order_by,
        order_dir,
      },
    };
    return this.http
      .get("/api/bbva_movements/to_assign", options)
      .pipe(tap((_) => console.log("BbvaMovementsService.getUnassignedBBVAMovements: Ok.")));
  }

  public bulkBBVAMovementsCreation(bbva_movements = []) {
    return this.http
      .post("/api/bbva_movements/create_bulk_movement", { bbva_movements })
      .pipe(tap((_) => console.log("BbvaMovementsService.bulkBBVAMovementsCreation: Ok.")));
  }

  public createPayment(bbva_movement = {}) {
    return this.http
      .post("/api/bbva_movements", { bbva_movement })
      .pipe(tap((_) => console.log("BbvaMovementsService.createPayment: Ok.")));
  }

  public reconcilePayment(bbva_movement = {}) {
    return this.http
      .post("/api/bbva_movements/reconciled_movement", { bbva_movement })
      .pipe(tap((_) => console.log("BbvaMovementsService.reconcilePayment: Ok.")));
  }

  public BBVAMovementCancelMovement(id, cancel_reason) {
    return this.http
      .put("/api/bbva_movements/" + id + "/cancel_movement", { cancel_reason })
      .pipe(tap((_) => console.log("BbvaMovementsService.BBVAMovementCancelMovement: Ok.")));
  }
}
